import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the accounts and factoring api
 */
export class RoutingToolsService extends BaseService {

	constructor() {	
		super();
	}

	async generalGeocode(geocodeRequest) {
		var data = await this.makePOSTRequest('/api/service/routing/geo-code', geocodeRequest);	
		return data;		
	}

	async geocode(geocodeRequest) {
		var data = await this.makePOSTRequest('/api/service/routing-tools/geo-code', geocodeRequest);	
		return data;		
	}
	
	async geotunnel(geotunnelRequest) {
		var data = await this.makePOSTRequest('/api/service/routing-tools/geotunnel', geotunnelRequest);	
		return data;		
	}	
	
	async routingPoint(routeRequest) {
		var data = await this.makePOSTRequest('/api/service/routing-tools/routing/point', routeRequest);	
		return data;		
	}
	
	async crowFly(crowflyRequest) {
		var data = await this.makePOSTRequest('/api/service/routing-tools/routing/crowfly', crowflyRequest);	
		return data;		
	}	
	
	async routingPipeline(pipelineRequest) {
		var data = await this.makePOSTRequest('/api/service/routing-tools/routing/pipeline', pipelineRequest);	
		return data;		
	}		

	async routingTrip(routeRequest) {
		var data = await this.makePOSTRequest('/api/service/routing-tools/routing/trip', routeRequest);	
		return data;		
	}

	async routingDetails(routeRequest) {
		var data = await this.makePOSTRequest('/api/service/routing-tools/routing/details', routeRequest);	
		return data;		
	}	
	
}


